import { Link } from 'gatsby'
import React, { useContext } from 'react'

import { LocaleContext } from '../locale/i18n'
import { teamMemberUrl } from '../locale/pathing'
import { IContentfulTeamMember } from '../logic/shared-types'

import MeasurImage from './MeasurImage'

import './TeamMemberPageCard.scss'

const TeamMemberPageCard = ({
  metaDescription: { metaDescription },
  teamMember,
  slug,
}: IContentfulTeamMember) => {
  const { interpolate, locale } = useContext(LocaleContext)
  return (
    <Link className="teamMemberPageCard" to={teamMemberUrl(locale, slug)}>
      <div className="teamMemberPageCard__header">
        {teamMember.avatar ? (
          <MeasurImage
            className="teamMemberPageCard__avatar"
            alt={teamMember.name}
            image={teamMember.avatar.gatsbyImageData}
          />
        ) : null}
        <div>
          <h3 className="teamMemberPageCard__name">{teamMember.name}</h3>
          <p>{teamMember.title}</p>
        </div>
      </div>
      <div className="teamMemberPageCard__intro">{metaDescription}</div>
      <span className="teamMemberPageCard__link">
        {interpolate('teamMemberPage.moreAbout', {
          name: teamMember.name.split(/\s+/g)[0],
        })}
      </span>
    </Link>
  )
}

export default TeamMemberPageCard
